import React from 'react';
import membanner from './img/members/membanner.jpg';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const schools = [
    {
        "img": require('./img/members/pope.jpg'),
        "name": "Pope Leo XIV"
        
        
    },
    {
        "img": require('./img/members/gen.jpg'),
        "name": "Rev. Fr. Arturo Sosa SJ",
        "title": "The Superior General"
        
    },
    {
        "img": require('./img/members/provincial.jpg'),
        "name": "Rev. Fr. Thomas Amirtham",
        "title": "Provincial"
        
    },
    {
        "img": require('./img/members/stephen.jpg'),
        "name": "Rev. Fr. Stephen Lourdu Pragasam SJ",
        "title": "Co-Ordinator"
        
    },
    {
        "img": require('./img/members/paul.jpg'),
        "name": "Rev. Fr. Paul Benedict SJ",
        "title": "Deputy Co-Ordinator"
        
    },
    {
        "img": require('./img/members/kennedy.jpg'),
        "name": "Rev. Fr. John Kennady SJ",
        "title": "Former Co-Ordinator"
    }
]

export default function MembersList() {
  return (
    <div style={{background: "linear-gradient(135deg, #f8fafc 60%, #e0e7ef 100%)", minHeight: "100vh"}}>
      <img style={{paddingBottom: "2%", width: "100%", maxHeight: "320px", objectFit: "cover", borderRadius: "0 0 24px 24px"}} className='img-fluid' src={membanner} alt='Members Banner' />
      <div className="container-fluid px-0 py-5">
        <div className="row mx-0 justify-content-center pt-5">
          <div className="col-lg-8">
            <div className=" text-center position-relative mb-4">
              <h6 className="d-inline-block position-relative text-primary text-uppercase pb-2" style={{letterSpacing: 2}}>Madurai Jesuit Schools</h6>
              <h1 className="display-5 fw-bold mb-3" style={{color: "#1a2740", fontWeight: 700, letterSpacing: 1}}>Members</h1>
              <p className="lead" style={{color: "#374151"}}>Meet the key members and leaders of the Madurai Jesuit Schools network.</p>
            </div>
          </div>
        </div>
        <div className='container'>
          <Row className="g-4 justify-content-center">
            {schools.map((item, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className='d-flex align-items-stretch'>
                <Card className="shadow-lg border-0 member-card" style={{transition: "transform 0.2s", borderRadius: 40, overflow: "hidden", background: "#fff", width: "100%", minWidth: 0, display: "flex", flexDirection: "column", height: "100%", maxWidth: "340px", margin: "auto"}}>
                  <Card.Img 
                    variant="top" 
                    src={item.img} 
                    alt={item.name} 
                    className="card-img-top member-photo"
                    style={{width: "120px", height: "120px", objectFit: "cover", objectPosition: "top center", borderRadius: "50%", margin: "28px auto 0 auto", boxShadow: "0 4px 24px rgba(44,62,80,0.14)", border: "4px solid #e0e7ef", background: "#f8fafc", display: "block"}}
                  />
                  <Card.Body className="d-flex flex-column justify-content-center text-center" style={{padding: "1.5rem", flex: "1 1 auto"}}>
                    <Card.Title className="mb-2" style={{fontWeight: 700, color: "#1a2740", fontSize: "1.15rem"}}>{item.name}</Card.Title>
                    <p>{item.title}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
      <style>{`
        .member-card {
          min-height: 370px;
          max-width: 340px;
        }
        @media (max-width: 991.98px) {
          .member-card {
            max-width: 100%;
            min-height: 320px;
          }
        }
        @media (max-width: 575.98px) {
          .member-card {
            max-width: 100%;
            min-height: 260px;
            border-radius: 24px;
          }
          .member-card .member-photo {
            width: 80px !important;
            height: 80px !important;
            margin: 16px auto 0 auto !important;
          }
          .member-card .card-body {
            padding: 1rem !important;
          }
        }
        .member-card .member-photo {
          transition: box-shadow 0.2s, transform 0.2s;
        }
        .member-card:hover .member-photo {
          box-shadow: 0 8px 32px 0 rgba(44,62,80,0.22);
          transform: scale(1.08);
        }
        .member-card:hover {
          box-shadow: 0 8px 32px 0 rgba(44,62,80,0.18);
          transform: translateY(-4px) scale(1.02);
        }
      `}</style>
    </div>
  )
}
